<template>
  <div class="three-pillars">
    <div class="pillar-item">
      <router-link :to="{ name: 'eat-right' }">
        <img class="pillar-icon" src="../assets/svg/eat-right.svg" alt="">
        <span class="sr-only">Eat Right - Nutrition</span>
      </router-link>
    </div>
    <div class="pillar-item">
      <router-link :to="{ name: 'work-hard' }">
        <img class="pillar-icon" src="../assets/svg/work-hard.svg" alt="">
        <span class="sr-only">Work Hard - Fitness</span>
      </router-link>
    </div>
    <div class="pillar-item">
      <router-link :to="{ name: 'be-accountable' }">
        <img class="pillar-icon" src="../assets/svg/be-accountable.svg" alt="">
        <span class="sr-only">Be Accountable - Consistency</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.three-pillars {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  .pillar-item {
    width: 80%;
    max-width: 220px;
    margin: 0 0 30px 0;

    a {
      text-decoration: none;
    }

    .pillar-icon {
      width: 100%;
      height: auto;
    }
  }

  @include media-breakpoint-up(sm) {
    flex-flow: row nowrap;
    justify-content: center;

    .pillar-item {
      width: (100%/3);
      max-width: none;
      padding: 15px;
    }
  }

  @include media-breakpoint-up(lg) {

  }

  @include media-breakpoint-up(xl) {
    .pillar-item {
      max-width: 400px;
    }
  }
}
</style>
